import { render } from "./Splash.vue?vue&type=template&id=08a19782&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=08a19782&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08a19782"

export default script